<template>
  <select>
    <slot></slot>
  </select>
</template>

<script>
import $ from "jquery";
//import selectric from "selectric";
require("selectric");

//$ = $.extend(jui);
//$ = $.extend(selectric);

const props = {
  //name: "selectric-component",
};

export default {
  props,
  mounted: function () {
    /** */
    var vm = this;
    $(vm.$el).selectric({});
    $(this.$el).on("selectric-change", (event, el) => {
      event;
      this.dispatchInputEvent(el.value);
    });
    //.trigger('change')
    //.on('change', function (e) {
    //    console.log($(e.target).find(":selected").text());
    //$('#aioConceptName').find(":selected").text();
    //vm.$emit('input', this.value);
    //});
    /** */
  },
  methods: {
    dispatchInputEvent(value) {
      this.$emit("input", value, this);
      this.$emit("blur", value, this);
    },

    refresh() {
      $(this.$el).selectric("refresh");
    },
  },
  destroyed: function () {
    $(this.$el).off().selectric("destroy");
  },
};
</script>

<style scoped>
@import "../assets/css/selectric.css";
</style>
